/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/10/8 16:44
 * @FileName: foreignExchange.js
 * @LastEditor: 2022/10/8 16:44
 * @Name: foreignExchange
 */


const foreignExchange = {
  routes: [
    {
      path: '/foreignExchange',
      name: 'foreignExchange',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/foreign-exchange/foreign-exchange.vue')
    }
  ]
};
export default foreignExchange;




// WEBPACK FOOTER //
// ./src/project/router/foreignExchange.js